module.exports = __webpack_public_path__ + "img/Screenshot_2.7d6a17ce.png";